var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true },
        },
      ],
      staticClass: "app-container",
      attrs: { "element-loading-text": "加载中..." },
    },
    [
      _c(
        "el-card",
        {
          staticClass: "sticky-container",
          attrs: { shadow: "never", "body-style": { padding: 0 } },
        },
        [
          _c(
            "template",
            { slot: "header" },
            [
              _c(
                "el-tabs",
                {
                  on: { "tab-click": _vm.handleFilter },
                  model: {
                    value: _vm.queryParams.isOnsale,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryParams, "isOnsale", $$v)
                    },
                    expression: "queryParams.isOnsale",
                  },
                },
                [
                  _c("el-tab-pane", { attrs: { label: "未审核", name: "0" } }),
                  _c("el-tab-pane", {
                    attrs: { label: "审核通过", name: "1" },
                  }),
                  _c("el-tab-pane", {
                    attrs: { label: "审核未通过", name: "2" },
                  }),
                  _c("el-tab-pane", { attrs: { label: "删除中", name: "3" } }),
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "filter-container", attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 6 } },
                    [
                      _c("el-input", {
                        staticClass: "filter-item",
                        attrs: { placeholder: "商品名称", clearable: "" },
                        model: {
                          value: _vm.queryParams.goodsName,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "goodsName", $$v)
                          },
                          expression: "queryParams.goodsName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 3 } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "filter-item",
                          attrs: { placeholder: "供应商", clearable: "" },
                          model: {
                            value: _vm.queryParams.supplierId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "supplierId", $$v)
                            },
                            expression: "queryParams.supplierId",
                          },
                        },
                        _vm._l(_vm.supplierList, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { value: item.id, label: item.supplierName },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 9 } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          attrs: { type: "primary", icon: "el-icon-search" },
                          on: { click: _vm.handleFilter },
                        },
                        [_vm._v("查找")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                { name: "sticky-header", rawName: "v-sticky-header" },
              ],
              attrs: {
                stripe: "",
                fit: "",
                "highlight-current-row": "",
                data: _vm.list,
                "header-cell-class-name": "table-header-cell",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "序号",
                  width: "60",
                  align: "center",
                  type: "index",
                  "class-name": "table-header-cell",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              scope.$index +
                                1 +
                                (_vm.queryParams.page - 1) *
                                  _vm.queryParams.limit
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "供应商",
                  prop: "supplierName",
                  "min-width": "150",
                  "class-name": "name-col",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "商品名称",
                  prop: "goodsName",
                  "min-width": "150",
                  "class-name": "name-col",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "商品图片",
                  prop: "cover",
                  width: "100",
                  "class-name": "image-col",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("el-image", {
                          attrs: {
                            src: row.cover,
                            "preview-src-list": [row.cover],
                            lazy: "",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "供货价",
                  prop: "stockPrice",
                  width: "90",
                  align: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(_vm._s(_vm._f("filterPrice")(row.stockPrice))),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "建议售价",
                  prop: "retailPrice",
                  width: "80",
                  align: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(_vm._s(_vm._f("filterPrice")(row.retailPrice))),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "状态", width: "100", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.status === 3
                          ? _c(
                              "el-tag",
                              { attrs: { type: "info", effect: "dark" } },
                              [_vm._v("删除中")]
                            )
                          : row.status === 2
                          ? _c(
                              "el-tag",
                              { attrs: { type: "danger", effect: "dark" } },
                              [_vm._v("未通过")]
                            )
                          : row.status === 1
                          ? _c("el-tag", { attrs: { effect: "dark" } }, [
                              _vm._v("已通过"),
                            ])
                          : _c(
                              "el-tag",
                              { attrs: { type: "info", effect: "plain" } },
                              [_vm._v("未审核")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", width: "80", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-dropdown",
                          { attrs: { trigger: "click" } },
                          [
                            _c("span", { staticClass: "el-dropdown-link" }, [
                              _vm._v(" 操作"),
                              _c("i", {
                                staticClass:
                                  "el-icon-arrow-down el-icon--right",
                              }),
                            ]),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: { disabled: row.status !== 0 },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.handleApprove(row.id)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-check" }),
                                    _vm._v(" 审核"),
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      disabled: row.status > 1,
                                      divided: "",
                                    },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.handleOnsale(row.id)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-upload2" }),
                                    _vm._v(" 上架"),
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      disabled: row.status !== 3,
                                      divided: "",
                                    },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.handleRemove(row.id)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-delete" }),
                                    _vm._v(" 确认删除"),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("pagination", {
            attrs: {
              total: _vm.total,
              page: _vm.queryParams.page,
              limit: _vm.queryParams.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.queryParams, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.queryParams, "limit", $event)
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.approveLoading,
              expression: "approveLoading",
            },
          ],
          attrs: {
            title: _vm.dialogTitle,
            width: "80%",
            top: "5vh",
            "custom-class": "dialog-scrollbar",
            visible: _vm.dialogVisible,
            fullscreen: _vm.device === "mobile",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "10px" },
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm.isApprove
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-popover",
                            {
                              attrs: { title: "审核不通过", placement: "top" },
                              on: {
                                hide: function ($event) {
                                  _vm.approveMessage = ""
                                },
                              },
                              model: {
                                value: _vm.approveVisible,
                                callback: function ($$v) {
                                  _vm.approveVisible = $$v
                                },
                                expression: "approveVisible",
                              },
                            },
                            [
                              _c(
                                "p",
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入不通过的理由",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.approveMessage,
                                      callback: function ($$v) {
                                        _vm.approveMessage = $$v
                                      },
                                      expression: "approveMessage",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "flex align-center just-end" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "medium" },
                                      on: {
                                        click: function ($event) {
                                          _vm.approveVisible = false
                                        },
                                      },
                                    },
                                    [_vm._v("取消")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onApproved(2)
                                        },
                                      },
                                    },
                                    [_vm._v("确定")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { slot: "reference", type: "info" },
                                  slot: "reference",
                                },
                                [_vm._v("不通过")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "10px" },
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.onApproved(1)
                                },
                              },
                            },
                            [_vm._v("审核通过")]
                          ),
                        ],
                        1
                      )
                    : _c(
                        "el-popover",
                        {
                          attrs: { title: "选择上架位置", placement: "top" },
                          on: {
                            hide: function ($event) {
                              _vm.malls = []
                            },
                          },
                          model: {
                            value: _vm.onsaleVisible,
                            callback: function ($$v) {
                              _vm.onsaleVisible = $$v
                            },
                            expression: "onsaleVisible",
                          },
                        },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              staticClass:
                                "el-checkbox-group-column padding-wrapper margin-wrapper",
                              model: {
                                value: _vm.malls,
                                callback: function ($$v) {
                                  _vm.malls = $$v
                                },
                                expression: "malls",
                              },
                            },
                            _vm._l(_vm.mallList, function (item) {
                              return _c(
                                "el-checkbox",
                                { key: item.id, attrs: { label: item.id } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "flex align-center just-end" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "medium" },
                                  on: {
                                    click: function ($event) {
                                      _vm.onsaleVisible = false
                                    },
                                  },
                                },
                                [_vm._v("取消")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.onSale },
                                },
                                [_vm._v("确定")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { slot: "reference", type: "primary" },
                              slot: "reference",
                            },
                            [_vm._v("商品上架")]
                          ),
                        ],
                        1
                      ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [_c("good-detail", { attrs: { detail: _vm.detail } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }